module.exports = __webpack_public_path__ + "static/media/Double-arrow-left.223a2b1a.svg";